<template>
    <Paper :header="$t('companyDetail.articles.header')" class="articles-root">
        <div v-if="!items" style="padding-bottom: 20px;">
            <ImageTextSkeleton />
        </div>
        <Carousel
            v-else
            :items="items"
            :component="getComponent()"
            onlyShowSingleItem
            :noResourcesImage="noArticleImage"
            :noResourcesMessage="$t('companyDetail.articles.noArticles')"
        />
    </Paper>
</template>

<script>
import ArticlesCarouselItem from '~/components/miscellaneous/Articles.CarouselItem';
import ImageTextSkeleton from '~/components/skeletons/ImageTextSkeleton';
import ArticleSvg from '~/assets/img/article.svg';

export default {
    name: 'Articles',

    components: { ImageTextSkeleton },

    props: {
        items: Array,
    },
    data: () => ({
        noArticleImage: ArticleSvg,
    }),
    methods: {
        getComponent() {
            return ArticlesCarouselItem;
        },
    },
};
</script>

<style scoped>
.articles-root {
    overflow: hidden;
    max-height: 100%;
    max-width: 100%;
}

.articles {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-flow: column;
    grid-gap: 25px;
}

.article-item {
    cursor: pointer;
}
.article-item:hover img {
    transform: scale(1.02);
}
</style>
